import { CockpitMode, IssueStatus } from './type';
import { MapLayerEnum } from './enum';
import no_signal from '@/assets/images/monitor/no_signal.png';
import signal_1 from '@/assets/images/monitor/signal_1.png';
import signal_2 from '@/assets/images/monitor/signal_2.png';
import signal_3 from '@/assets/images/monitor/signal_3.png';
import signal_4 from '@/assets/images/monitor/signal_4.png';
import signal_5 from '@/assets/images/monitor/signal_5.png';
export const GeerPosition: any = {
  '0': 'N',
  '1': 'D',
  '2': 'R',
  '3': 'P',
};

export enum ControlType {
  SPEED = 'SPEED',
  ANGLE = 'ANGLE',
}

export enum ControlDirection {
  TURN_LEFT = 'TURN_LEFT',
  TURN_RIGHT = 'TURN_RIGHT',
  BACK_TO_NORMAL = 'BACK_TO_NORMAL',
}

export enum ControlSpeed {
  SLOW_DOWN = 'SLOW_DOWN',
  SPEED_UP = 'SPEED_UP',
  BRAKE = 'BRAKE',
}

export enum SystemState {
  UNKNOWN = '',
  OFFLINE = '离线',
  NORMAL = '正常',
  SELF_REPAIR = '自修复中',
  MALFUNCTION = '系统故障',
  CONNECTION_LOST = '失联',
}
export enum SystemStateEnum {
  UNKNOWN = 'UNKNOWN',
  OFFLINE = 'OFFLINE',
  NORMAL = 'NORMAL',
  SELF_REPAIR = 'SELF_REPAIR',
  MALFUNCTION = 'MALFUNCTION',
  CONNECTION_LOST = 'CONNECTION_LOST',
}
export enum VehicleScheduleState {
  UNKNOWN = '',
  WAITING = '无任务',
  ALREADY = '待出发',
  SETOUT = '去程',
  DELIVERY = '任务中',
  RETURN = '返程',
  ARRIVED = '已到达',
  TOLOAD = '去装载',
  LOADING = '装载中',
  TOUNLOAD = '去卸载',
  UNLOADING = '卸载中',
  INITIAL = '待分配',
  ASSIGNED = '已分配',
  COLLECTING = '揽收中',
}

export enum VehicleScheduleStateEnum {
  UNKNOWN = 'UNKNOWN',
  WAITING = 'WAITING',
  ALREADY = 'ALREADY',
  SETOUT = 'SETOUT',
  DELIVERY = 'DELIVERY',
  RETURN = 'RETURN',
  ARRIVED = 'ARRIVED',
  TOLOAD = 'TOLOAD',
  LOADING = 'LOADING',
  TOUNLOAD = 'TOUNLOAD',
  UNLOADING = 'UNLOADING',
  INITIAL = 'INITIAL',
  ASSIGNED = 'ASSIGNED',
  COLLECTING = 'COLLECTING',
}

export enum VehicleState {
  UNKNOWN = '',
  INITIALIZATION = '初始化',
  READY = '无任务待机',
  AUTO_DRIVE = '自动驾驶',
  ABNORMAL_STOP = '异常停车',
  REMOTE_CONTROL = '远程控制',
  LOCAL_CONTROL = '手柄控制',
  GUARDIAN_TAKE_OVER = '安全接管',
  EMERGENCY_STOP = '车端拍停',
  CHASSIS_FAULT = '底盘故障停车',
  XBOX_CTRL = 'XBOX控制',
  GUARDIAN_EMERGENCY = '安全急停',
  CHASSIS_STANDBY = '底盘待机',
  BUMPER_STOP = '防撞停车',
  REMOTE_SUPER_CTRL = '强制遥控',
  REMOTE_JOYSTICK_CTRL = '平行驾驶',
  REMOTE_JOYSTICK_SUPER_CTRL = '超管驾驶',
}

export enum VehicleStateEnum {
  UNKNOWN = '',
  INITIALIZATION = 'INITIALIZATION',
  READY = 'READY',
  AUTO_DRIVE = 'AUTO_DRIVE',
  ABNORMAL_STOP = 'ABNORMAL_STOP',
  REMOTE_CONTROL = 'REMOTE_CONTROL',
  LOCAL_CONTROL = 'LOCAL_CONTROL',
  GUARDIAN_TAKE_OVER = 'GUARDIAN_TAKE_OVER',
  EMERGENCY_STOP = 'EMERGENCY_STOP',
  CHASSIS_FAULT = 'CHASSIS_FAULT',
  XBOX_CTRL = 'XBOX_CTRL',
  GUARDIAN_EMERGENCY = 'GUARDIAN_EMERGENCY',
  CHASSIS_STANDBY = 'CHASSIS_STANDBY',
  BUMPER_STOP = 'BUMPER_STOP',
  REMOTE_SUPER_CTRL = 'REMOTE_SUPER_CTRL',
  REMOTE_JOYSTICK_CTRL = 'REMOTE_JOYSTICK_CTRL',
  REMOTE_JOYSTICK_SUPER_CTRL = 'REMOTE_JOYSTICK_SUPER_CTRL',
}

export enum DriveModeKey {
  UNKNOWN = 'UNKNOWN',
  DRIVEMODE_ENGAGED_INIT = 'DRIVEMODE_ENGAGED_INIT',
  DRIVEMODE_ENGAGED_AUTO_CTRL = 'DRIVEMODE_ENGAGED_AUTO_CTRL',
  DRIVEMODE_TAKEOVER_REMOTE_CTRL = 'DRIVEMODE_TAKEOVER_REMOTE_CTRL',
  DRIVEMODE_ENGAGED_GUARDIAN_NORMAL = 'DRIVEMODE_ENGAGED_GUARDIAN_NORMAL',
  DRIVEMODE_TAKEOVER_XBOX_CTRL = 'DRIVEMODE_TAKEOVER_XBOX_CTRL',
  DRIVEMODE_TAKEOVER_CHASSIS_CTRL = 'DRIVEMODE_TAKEOVER_CHASSIS_CTRL',
  DRIVEMODE_TAKEOVER_EMERGENCY_STOP = 'DRIVEMODE_TAKEOVER_EMERGENCY_STOP',
  DRIVEMODE_ENGAGED_GUARDIAN_EMERGENCY = 'DRIVEMODE_ENGAGED_GUARDIAN_EMERGENCY',
  DRIVEMODE_ENGAGED_GUARDIAN_FORBID_DRIVING = 'DRIVEMODE_ENGAGED_GUARDIAN_FORBID_DRIVING',
  DRIVEMODE_ENGAGED_CHASSIS_FAULT = 'DRIVEMODE_ENGAGED_CHASSIS_FAULT',
  DRIVEMODE_ENGAGED_CHASSIS_STANDBY = 'DRIVEMODE_ENGAGED_CHASSIS_STANDBY',
  DRIVEMODE_ENGAGED_CHASSIS_BUMPER = 'DRIVEMODE_ENGAGED_CHASSIS_BUMPER',
  DRIVEMODE_TAKEOVER_REMOTE_SUPER_CTRL = 'DRIVEMODE_TAKEOVER_REMOTE_SUPER_CTRL',
  DRIVEMODE_TAKEOVER_REMOTE_MOBILE_CTRL = 'DRIVEMODE_TAKEOVER_REMOTE_MOBILE_CTRL',
  DRIVEMODE_ENGAGED_GUARDIAN_COLLISION = 'DRIVEMODE_ENGAGED_GUARDIAN_COLLISION',
  DRIVEMODE_TAKEOVER_REMOTE_JOYSTICK_CTRL = 'DRIVEMODE_TAKEOVER_REMOTE_JOYSTICK_CTRL',
  DRIVEMODE_TAKEOVER_REMOTE_JOYSTICK_SUPER_CTRL = 'DRIVEMODE_TAKEOVER_REMOTE_JOYSTICK_SUPER_CTRL',
}

export enum DriveMode {
  UNKNOWN = '',
  DRIVEMODE_ENGAGED_INIT = '无任务待机',
  DRIVEMODE_ENGAGED_AUTO_CTRL = '自动驾驶',
  DRIVEMODE_TAKEOVER_REMOTE_CTRL = '远程控制',
  DRIVEMODE_ENGAGED_GUARDIAN_NORMAL = '安全接管',
  DRIVEMODE_TAKEOVER_XBOX_CTRL = 'XBOX控制',
  DRIVEMODE_TAKEOVER_CHASSIS_CTRL = '手柄控制',
  DRIVEMODE_TAKEOVER_EMERGENCY_STOP = '车端拍停',
  DRIVEMODE_ENGAGED_GUARDIAN_EMERGENCY = '安全急停',
  DRIVEMODE_ENGAGED_GUARDIAN_FORBID_DRIVING = '安全接管',
  DRIVEMODE_ENGAGED_CHASSIS_FAULT = '底盘故障停车',
  DRIVEMODE_ENGAGED_CHASSIS_STANDBY = '底盘待机',
  DRIVEMODE_ENGAGED_CHASSIS_BUMPER = '碰撞停车',
  DRIVEMODE_TAKEOVER_REMOTE_SUPER_CTRL = '强制遥控',
  DRIVEMODE_TAKEOVER_REMOTE_MOBILE_CTRL = '移动端远程控制',
  DRIVEMODE_ENGAGED_GUARDIAN_COLLISION = 'guardian碰撞',
  DRIVEMODE_TAKEOVER_REMOTE_JOYSTICK_CTRL = '平行驾驶',
  DRIVEMODE_TAKEOVER_REMOTE_JOYSTICK_SUPER_CTRL = '超管驾驶',
}

export enum AlarmEventType {
  UNKNOWN = '',
  VEHICLE_STOP_BUTTON = '按钮停车',
  VEHICLE_STOP_FATAL = '异常停车',
  VEHICLE_STOP_GUARDIAN = '安全接管停车',
  VEHICLE_STOP_TIMEOUT = '遇阻停车',
  VEHICLE_CRASH = '碰撞',
  LOW_BATTERY = '电量低',
  LOW_PRESSURE = '胎压异常',
  SENSOR_ERROR = '传感器异常',
  OPERATION_ALARM = '运营报警',
  VEHICLE_STOP_TRAFFICLIGHT_FAIL = '感知看灯失败',
  VEHICLE_STOP_INTERSECTION_STUCK = '路口遇阻',
  VEHICLE_STOP_TRAFFICLIGHT_TAKEUP = '看灯点被占',
  VEHICLE_STOP_TRAFFICLIGHT_ADJUST = '看灯规划失败',
  VEHICLE_STOP_STOP_TAKEUP = '停靠点被占',
  VEHICLE_STOP_STOP_ADJUST = '停靠规划失败',
  VEHICLE_CONNECTION_LOST = '车辆失联',

  //前端告警
  VEHICLE_SPEED_SLOW = '持续低速',
}

export enum ConnectionStatus {
  CONNECTION_OK = 1,
  CONNECTION_LOST = 2,
  CONNECTION_ERROR = 5,
  MESSAGE = 3,
  RELOGIN = 4,
}

export enum LightType {
  Red = 1, // 红灯
  Green = 2, //绿灯
  Yellow = 3, // 黄灯
  Disabled = 4, // 灯不亮
  Unknown = 5, // 未知
}

export enum MultiLightState {
  FLASHING_GREEN = 1, // 绿灯闪烁
  FLASHING_RED = 2, // 红灯闪烁
  FLASHING_YELLOW = 3, //黄灯闪烁
  None = 4, // 没有闪烁
}

export enum Scene {
  stop = 'STOP_AT',
  intersection = 'INTERSECTION',
}

export const sceneNameMap = new Map([
  [Scene.stop, '停靠'],
  [Scene.intersection, '路口'],
]);

export enum TopicPath {
  COCKPIT_TEAM_GROUP = 'r/drive/screenCockpitTeam/group/', // 驾驶团队信息
  SCREEN_COMMAND = 'r/drive/screen/command/', // 大屏多车页数据topic
  SCREEN_CONTROL_PAD = 'r/drive/screen/controlPad/', // 控制屏通知大屏
  CONTROL_PAD_WILL = 'r/drive/controlPad/will/', // 控制屏遗嘱
  SCREEN_WILL = 'r/drive/screen/will/', // 大屏遗嘱
  CONTROL_PAD_SCREEN = 'r/drive/controlPad/screen/', // 大屏通知控制屏
}

export enum MessageType {
  UNKNOWN_TYPE = 0, // 未知
  HEARTBEAT = 1, // 心跳
  CONF_INFO = 2, // conf数据
  CONNECT_STATUS = 3, // 方向盘、脚刹连接状态
  REALTIME_DATA = 4, // 实时数据
  STEERING_OPERATE = 5, // 方向盘操作
  SINGLE_VEHICLE_PAGE = 6, //单车页
}

export const ActionTypeMap = new Map([
  [MessageType.UNKNOWN_TYPE, 'UNKNOWN_TYPE'],
  [MessageType.HEARTBEAT, 'HEARTBEAT'],
  [MessageType.CONF_INFO, 'CONF_INFO'],
  [MessageType.CONNECT_STATUS, 'CONNECT_STATUS'],
  [MessageType.REALTIME_DATA, 'REALTIME_DATA'],
  [MessageType.STEERING_OPERATE, 'STEERING_OPERATE'],
]);

export enum OperateType {
  UNKNOWN = 0,
  ENTER_PAGE = 1,
  EXIT_PAGE = 2,
}

export enum RunMapState {
  RUN_HAVE_MAP = 'RUN_HAVE_MAP',
  RUN_NO_MAP = 'RUN_NO_MAP',
  UNKNOWN = 'UNKNOWN',
}

export enum PermissionButton {
  SPV_COCKPIT_MANAGE = 'SPV_COCKPIT_MANAGE',
  SPV_LISTENING_MODE = 'SPV_LISTENING_MODE',
  SPV_WATCH_CAR_MODE = 'SPV_WATCH_CAR_MODE',
  SPV_PATROL_MODE = 'SPV_PATROL_MODE',
  SPV_FREE_MODE = 'SPV_FREE_MODE',
  SPV_MAP_COLLECTION_MODE = 'SPV_MAP_COLLECTION_MODE',
}

export const runMapStateText = new Map([
  [RunMapState.RUN_HAVE_MAP, '有图'],
  [RunMapState.RUN_NO_MAP, '无图'],
  [RunMapState.UNKNOWN, ''],
]);

export const ModeOptions = [
  {
    label: '听单模式',
    value: CockpitMode.LISTENING_MODE,
    permissionId: PermissionButton.SPV_LISTENING_MODE,
  },
  {
    label: '盯车模式',
    value: CockpitMode.WATCH_CAR_MODE,
    permissionId: PermissionButton.SPV_WATCH_CAR_MODE,
  },
  {
    label: '巡查模式',
    value: CockpitMode.PATROL_MODE,
    permissionId: PermissionButton.SPV_PATROL_MODE,
  },
  {
    label: '采图模式',
    value: CockpitMode.MAP_COLLECTION_MODE,
    permissionId: PermissionButton.SPV_MAP_COLLECTION_MODE,
  },
  {
    label: '自由模式',
    value: CockpitMode.FREE_MODE,
    permissionId: PermissionButton.SPV_FREE_MODE,
  },
];

export enum MqttTopic {
  TEAM_INFO = `r/${process.env.JDX_APP_MQTT_ENV}/drive/cockpitTeamInfo/group/`,
  USER_INFO = `r/${process.env.JDX_APP_MQTT_ENV}/drive/userInfo/`,
  ISSUE_INFO = `r/${process.env.JDX_APP_MQTT_ENV}/drive/drawer/`,
  MQTT_WILL = `r/${process.env.JDX_APP_MQTT_ENV}/drive/screen/will/`,
  COMMAND_RESULT = `r/${process.env.JDX_APP_MQTT_ENV}/drive/commandResult/`,
}

export enum MessageState {
  INIT = 'INIT',
  RUNNING = 'RUNNING',
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export enum EventName {
  CREATE_MQTT_CLIENT = 'CREATE_MQTT_CLIENT',
  CLOSE_MQTT_CLIENT = 'CLOSE_MQTT_CLIENT',
  RESET_MAX_SPEED = 'RESET_MAX_SPEED',
  CHANGE_USER_CONFIG = 'CHANGE_USER_CONFIG',
  CHANGE_GEAR_POSITION = 'CHANGE_GEAR_POSITION',
}

export const TicketOperation = new Map([
  [
    'TICKET_CREATE',
    {
      code: 'TICKET_CREATE',
      name: '工单创建',
      keOperation: true,
    },
  ],
  [
    'TICKET_ACCEPT',
    {
      code: 'TICKET_ACCEPT',
      name: '工单受理',
      keOperation: true,
    },
  ],
  [
    'TICKET_HOLD',
    {
      code: 'TICKET_HOLD',
      name: '工单挂起',
      keOperation: true,
    },
  ],
  [
    'TICKET_CANCEL_HOLD',
    {
      code: 'TICKET_CANCEL_HOLD',
      name: '工单取消挂起',
      keOperation: true,
    },
  ],
  [
    'TICKET_TRANSFER',
    {
      code: 'TICKET_TRANSFER',
      name: '工单转单',
      keOperation: true,
    },
  ],
  [
    'TICKET_DISCARD',
    {
      code: 'TICKET_DISCARD',
      name: '工单抛单',
      keOperation: true,
    },
  ],
  [
    'TICKET_REMIND',
    {
      code: 'TICKET_REMIND',
      name: '工单催单',
      keOperation: true,
    },
  ],
  [
    'TICKET_CLOSE',
    {
      code: 'TICKET_CLOSE',
      name: '工单关闭',
      keOperation: true,
    },
  ],
  [
    'VEHICLE_OPERATION',
    {
      code: 'VEHICLE_OPERATION',
      name: '车辆操作',
      keOperation: false,
    },
  ],
  [
    'EVENT_CHANGE',
    {
      code: 'EVENT_CHANGE',
      name: '事件变更',
      keOperation: false,
    },
  ],
]);

export enum JIRA_SOURCE {
  ISSUE = 'ISSUE',
  ACCIDENT = 'ACCIDENT',
}

export enum MapState {
  RUN_HAVE_MAP = 'RUN_HAVE_MAP', // 有图模式
  RUN_NO_MAP = 'RUN_NO_MAP', // 无图模式
}

export const LOCALIZATION_ACCURACY: any = {
  LOCALIZATION_ACCURACY_0: {
    icon: no_signal,
  },
  LOCALIZATION_ACCURACY_1: {
    icon: signal_1,
  },
  LOCALIZATION_ACCURACY_2: {
    icon: signal_2,
  },
  LOCALIZATION_ACCURACY_3: {
    icon: signal_3,
  },
  LOCALIZATION_ACCURACY_4: {
    icon: signal_4,
  },
  LOCALIZATION_ACCURACY_5: {
    icon: signal_5,
  },
};

export enum RemoteCommandType {
  GEAR_PARK = 'GEAR_PARK',
  GEAR_DRIVE = 'GEAR_DRIVE',
  GEAR_NEUTRAL = 'GEAR_NEUTRAL',
  GEAR_REVERSE = 'GEAR_REVERSE',
  HAZARD_LIGHT_LEFT = 'HAZARD_LIGHT_LEFT',
  HAZARD_LIGHT_RIGHT = 'HAZARD_LIGHT_RIGHT',
  HAZARD_LIGHT_BOTH = 'HAZARD_LIGHT_BOTH',
  HAZARD_LIGHT_OFF = 'HAZARD_LIGHT_OFF',
  HEAD_LIGHT_ON = 'HEAD_LIGHT_ON',
  HEAD_LIGHT_OFF = 'HEAD_LIGHT_OFF',
  SUPER_MODE_ON = 'SUPER_MODE_ON',
  SUPER_MODE_OFF = 'SUPER_MODE_OFF',
  REMOTE_CONTROL_ON = 'REMOTE_CONTROL_ON', //开启遥控
  REMOTE_CONTROL_OFF = 'REMOTE_CONTROL_OFF', //关闭遥控
  RELEASE_AEB_BRAKE = 'RELEASE_AEB_BRAKE', // 释放AEB
}

export enum CLSTAG {
  // 座席管理
  CockpitBoard_Tab = 'realtime__1727334823926|73', // 座席看板tab
  CockpitBoard_CheckVehicle = 'realtime__1727334823926|74', // 座席看板-查看车辆
  CockpitBoard_CheckWorkOrder = 'realtime__1727334823926|75', // 座席看板-查看工单
  CockpitBoard_RemindIssue = 'realtime__1727334823926|76', // 座席看板-催单
  WorkOrderBoard_Tab = 'realtime__1727334823926|77', // 工单看板tab
  WorkOrderBoard_RemindIssue = 'realtime__1727334823926|78', // 工单看板-催单
  WorkOrderBoard_CheckWorkOrder = 'realtime__1727334823926|79', // 工单看板-查看工单
  BindVehicle_Tab = 'realtime__1727334823926|80', // 车辆绑定tab
  BindVehicle_Search = 'realtime__1727334823926|81', // 车辆绑定-查询

  // 单车页
  Throttle_Power = 'realtime__1728715455046|72', // 油门开度-动力
  Throttle_Standard = 'realtime__1728715455046|73', // 油门开度-标准
  Throttle_Stable = 'realtime__1728715455046|74', // 油门开度-稳定
  Throttle_Slow = 'realtime__1728715455046|75', // 油门开度-慢速
  TakeOver_Setting = 'realtime__1728715455046|76', // 接管配置按钮
}

export enum ListenModeClstag {
  // 听单模式 --- 多车页
  MultiPage_CockpitNumber = 'realtime__1727334823926|82', // 座席id
  MultiPage_Rest = 'realtime__1727334823926|83', // 休息
  MultiPage_RestAfterComplete = 'realtime__1727334823926|84', // 结单后休息
  MultiPage_Work = 'realtime__1727334823926|85', // 工作
  MultiPage_CockpitManage = 'realtime__1727334823926|86', // 座席管理
  MultiPage_SearchVehicle = 'realtime__1727334823926|87', // 搜索车辆
  MultiPage_Pagination_2 = 'realtime__1727334823926|88', // 分页方式-2
  MultiPage_Pagination_4 = 'realtime__1727334823926|89', // 分页方式-4
  MultiPage_Pagination_8 = 'realtime__1727334823926|90', // 分页方式-8

  // 听单模式 --- 工单抽屉
  Drawer_Expand = 'realtime__1727334823926|91', // 工单抽屉展开
  Drawer_Collapse = 'realtime__1727334823926|92', // 工单抽屉收起
  // 听单模式 --- 工单卡片
  Card_Transfer = 'realtime__1727334823926|93', // 转单
  Card_Complete = 'realtime__1727334823926|94', // 结单
  Card_Discard = 'realtime__1727334823926|95', // 抛单
  Card_OnHold = 'realtime__1727334823926|96', // 挂单
  Card_Expand = 'realtime__1727334823926|97', // 卡片展开
  Card_Collapse = 'realtime__1727334823926|98', // 卡片收起
  Card_OpenVideo = 'realtime__1727334823926|99', // 开启视频
  Card_CloseVideo = 'realtime__1727334823926|100', // 关闭视频
  Card_GoSingle = 'realtime__1728715455046|7', // 工单卡片进入单车页
  Notification_GoSingle = 'realtime__1728715455046|8', // 消息卡片进入单车页

  // 听单模式 --- 单车页
  SinglePage_HaveMap = 'realtime__1728715455046|9', // 有图模式
  SinglePage_NoMap = 'realtime__1728715455046|10', // 无图模式
  SinglePage_MapNavigation = 'realtime__1728715455046|11', // 地图导航
  SinglePage_BackIcon = 'realtime__1728715455046|12', // 返回按钮
  SinglePage_ChangeSpeed_TEN = 'realtime__1728715455046|13', // 切换速度-10级
  SinglePage_ChangeSpeed_NINE = 'realtime__1728715455046|14', // 切换速度-9级
  SinglePage_ChangeSpeed_EIGHT = 'realtime__1728715455046|15', //  切换速度-8级
  SinglePage_ChangeSpeed_SEVEN = 'realtime__1728715455046|65', // 切换速度-7级
  SinglePage_ChangeSpeed_SIX = 'realtime__1728715455046|66', // 切换速度-6级
  SinglePage_ChangeSpeed_FIVE = 'realtime__1728715455046|67', // 切换速度-5级
  SinglePage_ChangeSpeed_FOUR = 'realtime__1728715455046|68', // 切换速度-4级
  SinglePage_ChangeSpeed_THREE = 'realtime__1728715455046|69', // 切换速度-3级
  SinglePage_ChangeSpeed_TWO = 'realtime__1728715455046|70', // 切换速度-2级
  SinglePage_ChangeSpeed_ONE = 'realtime__1728715455046|71', // 切换速度-1级
  SinglePage_ChangeSpeed_NoLimit = 'realtime__1728715455046|16', // 切换速度-无限制
  SinglePage_EnterTakeOver = 'realtime__1728715455046|17', // 进入接管
  SinglePage_ExitTakeOver = 'realtime__1728715455046|18', // 退出接管
  SinglePgae_AsArrived = 'realtime__1728715455046|19', // 视同到达
  SinglePage_RemoveStop = 'realtime__1728715455046|20', // 解除拍停
  SinglePage_PowerOff = 'realtime__1728715455046|21', // 远程下电
  SinglePage_Reboot = 'realtime__1728715455046|22', // 断电重启
  SinglePage_SoftwareReboot = 'realtime__1728715455046|23', // 软件重启
  SinglePage_PowerOn = 'realtime__1728715455046|77', // 远程上电
  SinglePgae_OpenAudio = 'realtime__1728715455046|24', // 打开音频
  SinglePage_CloseAudio = 'realtime__1728715455046|25', // 关闭音频
  SinglePage_CompleteIssue = 'realtime__1728715455046|26', // 结单
  SinglePage_TransferIssue = 'realtime__1728715455046|27', // 转单
  SinglePage_DiscardIssue = 'realtime__1728715455046|28', // 抛单
  SinglePage_OnHoldIssue = 'realtime__1728715455046|29', // 挂单
  SinglePage_CompleteAndReportJisa = 'realtime__1728715455046|30', // 结单-点选一键提报
  SinglePage_CallFrontliner = 'realtime__1728715455046|31', // 呼叫一线
  SinglePage_WorkOrderHistory = 'realtime__1728715455046|32', // 工单历史
  SinglePage_WorkOrderRecord = 'realtime__1728715455046|33', // 工单历史-工单记录tab
  SinglePage_EventRecord = 'realtime__1728715455046|34', // 工单历史-事件记录tab
  SinglePage_ManualRecord = 'realtime__1728715455046|35', // 工单历史-人工记录tab
}

export enum FreeModeClstag {
  // 自由模式 --- 多车页
  MultiPage_CockpitNumber = 'realtime__1728715455046|1', // 座席id
  MultiPage_CockpitManage = 'realtime__1728715455046|2', // 座席管理
  MultiPage_SearchVehicle = 'realtime__1728715455046|3', // 搜索车辆
  MultiPage_Pagination_2 = 'realtime__1728715455046|4', // 分页方式-2
  MultiPage_Pagination_4 = 'realtime__1728715455046|5', // 分页方式-4
  MultiPage_Pagination_8 = 'realtime__1728715455046|6', // 分页方式-8

  // 自由模式 --- 单车页
  SinglePage_HaveMap = 'realtime__1728715455046|36', // 有图模式
  SinglePage_NoMap = 'realtime__1728715455046|37', // 无图模式
  SinglePage_MapNavigation = 'realtime__1728715455046|38', // 地图导航
  SinglePage_BackIcon = 'realtime__1728715455046|39', // 返回按钮
  SinglePage_ChangeSpeed_TEN = 'realtime__1728715455046|40', // 切换速度-10级
  SinglePage_ChangeSpeed_NINE = 'realtime__1728715455046|41', // 切换速度-9级
  SinglePage_ChangeSpeed_EIGHT = 'realtime__1728715455046|42', // 切换速度-8级
  SinglePage_ChangeSpeed_SEVEN = 'realtime__1728715455046|58', // 切换速度-7级
  SinglePage_ChangeSpeed_SIX = 'realtime__1728715455046|59', // 切换速度-6级
  SinglePage_ChangeSpeed_FIVE = 'realtime__1728715455046|60', // 切换速度-5级
  SinglePage_ChangeSpeed_FOUR = 'realtime__1728715455046|61', // 切换速度-4级
  SinglePage_ChangeSpeed_THREE = 'realtime__1728715455046|62', // 切换速度-3级
  SinglePage_ChangeSpeed_TWO = 'realtime__1728715455046|63', // 切换速度-2级
  SinglePage_ChangeSpeed_ONE = 'realtime__1728715455046|64', // 切换速度-1级
  SinglePage_ChangeSpeed_NoLimit = 'realtime__1728715455046|43', // 切换速度-无限制
  SinglePage_EnterTakeOver = 'realtime__1728715455046|44', // 进入接管
  SinglePage_ExitTakeOver = 'realtime__1728715455046|45', // 退出接管
  SinglePgae_AsArrived = 'realtime__1728715455046|46', // 视同到达
  SinglePage_RemoveStop = 'realtime__1728715455046|47', // 解除拍停
  SinglePage_PowerOff = 'realtime__1728715455046|48', // 远程下电
  SinglePage_Reboot = 'realtime__1728715455046|49', // 断电重启
  SinglePage_SoftwareReboot = 'realtime__1728715455046|50', // 软件重启
  SinglePage_PowerOn = 'realtime__1728715455046|78', // 远程上电
  SinglePgae_OpenAudio = 'realtime__1728715455046|51', // 打开音频
  SinglePage_CloseAudio = 'realtime__1728715455046|52', // 关闭音频
  SinglePage_CallFrontliner = 'realtime__1728715455046|53', // 呼叫一线
  SinglePage_WorkOrderHistory = 'realtime__1728715455046|54', // 工单历史
  SinglePage_WorkOrderRecord = 'realtime__1728715455046|55', // 工单历史-工单记录tab
  SinglePage_EventRecord = 'realtime__1728715455046|56', // 工单历史-事件记录tab
  SinglePage_ManualRecord = 'realtime__1728715455046|57', // 工单历史-人工记录tab
}
export enum TaskStatusEnum {
  UNDER_EXPLORATION = 'UNDER_EXPLORATION',
  PENDING_CLAIM = 'PENDING_CLAIM',
  COLLECTING = 'COLLECTING',
  PENDING_COPY = 'PENDING_COPY',
  COPYING = 'COPYING',
  COPY_COMPLETED = 'COPY_COMPLETED',
  MAP_IN_PROGRESS = 'MAP_IN_PROGRESS',
  MAP_RELEASE = 'MAP_RELEASE',
  TASK_CLOSED = 'TASK_CLOSED',
}

export const TaskStatusTextMap = new Map([
  [TaskStatusEnum.UNDER_EXPLORATION, '勘查中'],
  [TaskStatusEnum.PENDING_CLAIM, '待认领'],
  [TaskStatusEnum.COLLECTING, '采集中'],
  [TaskStatusEnum.PENDING_COPY, '待拷贝'],
  [TaskStatusEnum.COPYING, '拷贝中'],
  [TaskStatusEnum.COPY_COMPLETED, '拷贝完成'],
  [TaskStatusEnum.MAP_IN_PROGRESS, '地图制作中'],
  [TaskStatusEnum.MAP_RELEASE, '地图上线'],
  [TaskStatusEnum.TASK_CLOSED, '任务关闭'],
]);

export enum MarkType {
  INTERSECTION = 'INTERSECTION',
  ROAD_GAP = 'ROAD_GAP',
}

export enum CollectMapMode {
  COLLECTION = 'COLLECTION', // 采图模式
  NO_COLLECTION = 'NO_COLLECTION', // 非采图模式
}

export enum CollectionStatus {
  NOT_STARTED = 'NOT_STARTED', // 未开始
  PROCESSING = 'PROCESSING', // 进行中
  PAUSED = 'PAUSED', // 已暂停
}

export const CollectionStatusTextMap = new Map([
  [CollectionStatus.NOT_STARTED, '未开始'],
  [CollectionStatus.PROCESSING, '采集中'],
  [CollectionStatus.PAUSED, '采集暂停'],
]);
export enum SingleTabType {
  DRIVABLE = 'DRIVABLE',
  EXCEPTION = 'EXCEPTION',
  OPERATION = 'OPERATION',
  ACCIDENT = 'ACCIDENT',
}

export const initTileLayer = [
  {
    layerId: MapLayerEnum.INTERSECTION,
    url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_intersection_gcj02`,
      STYLES: 'intersection',
    },
  },
  {
    layerId: MapLayerEnum.CENTER_LINE,
    url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_lane_gcj02`,
      STYLES: 'line-center',
    },
  },
  {
    layerId: MapLayerEnum.STOP_LINE,
    url: `https://${process.env.JDX_APP_MAP_EDITOR}/geoserver/${process.env.JDX_APP_MAP_DATA}/wms`,
    params: {
      FORMAT: 'image/png',
      TILED: true,
      LAYERS: `${process.env.JDX_APP_MAP_DATA}:map_stop_line_gcj02`,
      STYLES: 'line-red',
    },
  },
];

export enum AccidentLevel {
  NONE = 'NONE',
  S0 = 'S0',
  S1 = 'S1',
  S2 = 'S2',
  S3 = 'S3',
  S4 = 'S4',
}

export const accidentLevelTooltipMap = {
  [AccidentLevel.S0]: '轻微碰撞且无人员伤害',
  [AccidentLevel.S1]: '碰撞且无人员伤害',
  [AccidentLevel.S2]: '碰撞且人员轻伤',
  [AccidentLevel.S3]: '碰撞且严重人员伤害',
  [AccidentLevel.S4]: '碰撞且人员致命伤害',
};

export enum GlobalEventName {
  JDX_FILE_UPLOAD_STATUS = 'file_upload_status', //文件上传状态
}

export enum PncTaskType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  NOTREADY = 'NOTREADY',
  ACTIVE = 'ACTIVE',
  ACCOMPLISHED = 'ACCOMPLISHED',
  CANCELLED = 'CANCELLED',
}

export enum ChargerConnectEnum {
  CHARGER_UNKNOWN = 'CHARGER_UNKNOWN',
  CHARGER_CONNECT = 'CHARGER_CONNECT',
  CHARGER_DISCONNECT = 'CHARGER_DISCONNECT',
}

export const ChargerConnectText = {
  [ChargerConnectEnum.CHARGER_CONNECT]: '已连接',
  [ChargerConnectEnum.CHARGER_DISCONNECT]: '未连接',
  [ChargerConnectEnum.CHARGER_UNKNOWN]: '未知',
};

export enum ChargeStateEnum {
  UNKNOWN = 'UNKNOWN',
  DISCHARGING = 'DISCHARGING',
  CHARGING = 'CHARGING',
  CHARGE_OK = 'CHARGE_OK',
}

export const ChargeStateText = {
  [ChargeStateEnum.DISCHARGING]: '未充电',
  [ChargeStateEnum.CHARGING]: '充电中',
  [ChargeStateEnum.CHARGE_OK]: '充电完成',
  [ChargeStateEnum.UNKNOWN]: '未知',
};
